import React from "react";
import { Hotel_y_tours } from "../EstadisticasHotel";

interface Props {
    data: Hotel_y_tours;
    isOpen: boolean;
    onClose: () => void;
}

function parsePercentStr(input?: string | null): number | null {
    if (!input) return null;

    const match = String(input).match(/[\d.,]+/);
    if (!match) return null;
    const normalized = match[0].replace(",", ".");
    const val = parseFloat(normalized);
    return Number.isFinite(val) ? val : null;
}

export const HotelToursComparativaModal: React.FC<Props> = ({
    data,
    isOpen,
    onClose,
}) => {
    if (!isOpen) return null;

    const total = data?.totalHabitaciones ?? 0;
    const conTours = data?.habitacionesConTours ?? 0;

    const porcentajeFromBackend = parsePercentStr(data?.porcentaje);

    const porcentajeCalc = total > 0 ? (conTours / total) * 100 : 0;

    const porcentajeNumber =
        porcentajeFromBackend !== null ? porcentajeFromBackend : porcentajeCalc;

    const porcentajeStr =
        data?.porcentaje && data.porcentaje !== ""
            ? data.porcentaje
            : `${Math.round(porcentajeCalc)}%`;

    const progress = Math.min(100, Math.max(0, porcentajeNumber));

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="relative w-11/12 p-6 bg-white rounded-lg shadow-lg md:w-8/12 lg:w-6/12">
                <button
                    onClick={onClose}
                    className="absolute text-gray-600 top-3 right-3 hover:text-gray-800"
                    aria-label="Cerrar modal">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <h2 className="mb-4 text-xl font-semibold text-center">
                    Comparativa: Habitaciones reservadas vs. con Tours
                </h2>

                <div className="grid grid-cols-1 gap-4 mb-4 sm:grid-cols-3">
                    <div className="p-4 text-center border rounded-lg">
                        <p className="text-sm text-gray-600">
                            Habitaciones reservadas
                        </p>
                        <p className="mt-1 text-2xl font-bold">{total}</p>
                    </div>
                    <div className="p-4 text-center border rounded-lg">
                        <p className="text-sm text-gray-600">Con tours</p>
                        <p className="mt-1 text-2xl font-bold">{conTours}</p>
                    </div>
                    <div className="p-4 text-center border rounded-lg">
                        <p className="text-sm text-gray-600">% con tours</p>
                        <p className="mt-1 text-2xl font-bold">
                            {porcentajeStr}
                        </p>
                    </div>
                </div>

                <div className="mb-2 text-sm text-gray-700">
                    Progreso de habitaciones con tours
                </div>
                <div
                    className="w-full h-4 overflow-hidden bg-gray-200 rounded-lg"
                    aria-label="Progreso porcentaje con tours">
                    <div
                        className="h-4 transition-all bg-indigo-500"
                        style={{ width: `${progress}%` }}
                    />
                </div>

                <div className="grid grid-cols-1 gap-2 mt-6 sm:grid-cols-2">
                    <div className="flex items-center gap-2">
                        <span className="inline-block w-3 h-3 rounded bg-indigo-500" />
                        <span className="text-sm text-gray-700">
                            Habitaciones con tours ({conTours})
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="inline-block w-3 h-3 bg-gray-300 rounded" />
                        <span className="text-sm text-gray-700">
                            Habitaciones sin tours (
                            {Math.max(total - conTours, 0)})
                        </span>
                    </div>
                </div>

                <p className="mt-4 text-xs text-center text-gray-500">
                    Este indicador muestra la proporción de reservas de
                    habitación que también contrataron tours en el período
                    seleccionado.
                </p>
            </div>
        </div>
    );
};
